import React, { useState, useEffect } from 'react'
import { navigate } from 'gatsby'
import { CgChevronRight } from 'react-icons/cg'
import { isExternalLink } from '@utils/tools'
import GatsbyMediaByName from '@components/GatsbyMediaByName'
export const onNavigate = (link, callback) => {
  if (!link) return
  navigate(link)
  if (callback) callback()
}

export const LinkCustom = (props) => {
  const { to, children, callback, className } = props
  const isExternal = isExternalLink(to)
  return isExternal ? (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  ) : (
    <div
      role="button"
      className={`${className}`}
      aria-label="nav link"
      onClick={() => {
        onNavigate(to, callback)
      }}
      // {...props}
    >
      {children}
    </div>
  )
}

export const CardSecondCategory = ({ list, className, onNavChange }) => {
  const [active, setActive] = useState('')

  useEffect(() => {
    if (list && list.length > 0) {
      const firstItem = list[0]
      setActive(firstItem.title)
    }
  }, [list])
  // 渲染缩略图的辅助函数
  const renderThumbnail = (thumbnailName, title, className = '') => {
    if (!thumbnailName) return null

    // 如果包含 http，使用 img 标签
    if (thumbnailName.includes('http')) {
      return (
        <img
          className={className || 'max-w-full max-h-full'}
          src={thumbnailName}
          alt={title}
        />
      )
    }

    // 否则使用 GatsbyMediaByName
    return (
      <GatsbyMediaByName
        name={thumbnailName}
        className={className || 'max-w-full max-h-full'}
        alt={title}
      />
    )
  }

  const renderMenuItems = (list, prefix = '') => {
    return list.map((item, index) => {
      const { title, link, children, thumbnailName, description } = item
      return (
        <div
          key={`item-${item.title}-${index}`}
          className="menu-item flex-shrink-0 flex-grow-0 h-[9.79vw] w-[9.48vw] max-w-[180px] max-h-[188px] bg-[var(--grey-30)] mr-[10px] rounded-[4px]"
        >
          <LinkCustom
            to={link}
            className="menu-item-link w-full h-full flex flex-col overflow-hidden text-center py-3"
            callback={onNavChange}
          >
            {thumbnailName && (
              <div className="menu-item-thumbnail overflow-hidden flex-1 mx-auto">
                {renderThumbnail(thumbnailName, title)}
              </div>
            )}
            <div className="menu-item-title mt-2 text-fluid-xs font-medium whitespace-nowrap">
              {title}
            </div>
            {/* {description && (
              <div className="menu-item-description">{description}</div>
            )} */}
          </LinkCustom>
          {/* 如果有子元素，递归调用 */}
          {children && children.length > 0 && (
            <div className="menu-item-children-container transition-all duration-300 ease-in-out">
              {renderMenuItems(children)}
            </div>
          )}
        </div>
      )
    })
  }
  return (
    <div
      className={`card-category-container px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-24 w-full flex items-start ${className}`}
    >
      <div className="card-category-left flex flex-col justify-start mr-[48px]">
        {list.map((item, index) => {
          const { title, link, children, description } = item
          const isActive = active === title
          return (
            <div
              className={`card-category-item flex items-center justify-between hover:bg-[var(--grey-30)] px-3 py-4
                text-fluid-sm
                font-semibold
                lg:min-w-[150px] 2xl:min-w-[250px]
                cursor-pointer ${isActive ? 'bg-[var(--grey-30)]' : ''}`}
              key={`item-${index}`}
              onMouseOver={() => {
                setActive(title)
              }}
            >
              <LinkCustom to={link} callback={onNavChange}>
                {title}
              </LinkCustom>
              {children && children.length > 0 && <CgChevronRight />}
            </div>
          )
        })}
      </div>
      <div className="card-category-right flex-1">
        {list.map((item, index) => {
          const { title, description, children } = item
          const isActive = active === title
          return (
            <div
              className={`card-category-children-container overflow-hidden transition-[width] duration-0 ease-in-out ${
                isActive ? 'w-full' : 'w-0 h-0'
              }`}
              key={`card-children-${index}`}
            >
              {description && (
                <div className="text-fluid-xs text-gray-800 border-b border-gray-200 pb-1 mb-4">
                  {description}
                </div>
              )}
              <div className="flex ">
                {children && children.length > 0 ? (
                  renderMenuItems(children)
                ) : (
                  <div className="card-category-children-description">
                    {description}
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
